export const receiveStatus = {
	open: "Open",
	draft: "Draft",
	inProgress: "InProgress",
	pendingReview: "PendingReview",
	reviewing: "Reviewing",
	pendingReceive: "PendingReceive",
	pendingFinalise: "Incomplete",
	completed: "Completed",
	cancelled: "Cancelled",
	receivedDirectly: "ReceivedDirectly",
	arrived: "Arrived",
};

export const arrivalStatus = {
	complete: "Complete",
	incomplete: "Incomplete",
	unknown: "Uknown",
};

export const arrivalCheckinMethod = {
	manual: "Manual",
	ssccScan: "SsccScan",
};

export const statusSortOrder = [
	receiveStatus.open,
	receiveStatus.inProgress,
	receiveStatus.pendingReview,
	receiveStatus.reviewing,
	receiveStatus.pendingReceive,
	receiveStatus.pendingFinalise,
	receiveStatus.completed,
	receiveStatus.receivedDirectly,
	receiveStatus.cancelled,
];

export const closedStatusList = [receiveStatus.completed, receiveStatus.cancelled, receiveStatus.receivedDirectly];

export const canBeFinalisedStatusList = [
	receiveStatus.inProgress,
	receiveStatus.pendingReceive,
	receiveStatus.reviewing,
	receiveStatus.pendingFinalise,
];

export const canBeClearedStatusList = [
	receiveStatus.inProgress,
	receiveStatus.pendingFinalise,
	receiveStatus.pendingReceive,
	receiveStatus.pendingReview,
	receiveStatus.reviewing,
	receiveStatus.arrived,
];

export const alreadyAllocatedCustomerOrdersList = [
	receiveStatus.pendingReview,
	receiveStatus.pendingFinalise,
	receiveStatus.pendingReceive,
];

export const blockEdiScanStatusList = [
	receiveStatus.completed,
	receiveStatus.pendingFinalise,
	receiveStatus.cancelled,
	receiveStatus.receivedDirectly
];

export const blockManualScanStatusList = [
	receiveStatus.completed,
	receiveStatus.cancelled,
	receiveStatus.receivedDirectly,
];
